import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts';
import { BarChart3 } from 'lucide-react';
import { MONTHS_RO, fmtRon } from './reportUtils';

export const MonthlyBarChart = ({ months, year }) => {
    const data = [...months].sort((a, b) => a.month - b.month).map(m => ({
        name: MONTHS_RO[m.month - 1].slice(0, 3),
        Vânzări: m.sales,
        Cheltuieli: m.expenses,
    }));
    return (
        <div data-testid="monthly-bar-chart" className="bg-white border border-zinc-200 rounded-xl p-4 mb-4">
            <h2 className="font-bold text-zinc-800 mb-4 flex items-center gap-2">
                <BarChart3 size={20} className="text-violet-600" />
                Vânzări și Cheltuieli pe luni — {year}
            </h2>
            <div className="h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e4e4e7" />
                        <XAxis dataKey="name" tick={{ fontSize: 12, fill: '#71717a' }} />
                        <YAxis tick={{ fontSize: 11, fill: '#71717a' }} tickFormatter={(v) => v.toLocaleString('ro-RO')} width={70} />
                        <Tooltip formatter={(v) => fmtRon(v)} />
                        <Legend itemSorter={(item) => (item.value === 'Vânzări' ? 0 : 1)} />
                        <Bar dataKey="Vânzări" fill="#7c3aed" radius={[4, 4, 0, 0]} />
                        <Bar dataKey="Cheltuieli" fill="#ef4444" radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};
